<router-outlet />
<app-ai-chat />
<ngx-loading backdropBackgroundColor="#64bd8599" [filteredHeaders]="filteredHeaders">
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		style="margin: auto; display: block"
		width="256px"
		height="256px"
		viewBox="0 0 100 100"
		preserveAspectRatio="xMidYMid"
	>
		<circle
			cx="50"
			cy="50"
			r="30"
			stroke="#64bd85"
			stroke-width="8"
			stroke-linecap="round"
			fill="none"
		>
			<animateTransform
				attributeName="transform"
				type="rotate"
				repeatCount="indefinite"
				dur="1.5s"
				values="0 50 50;180 50 50;720 50 50"
				keyTimes="0;0.5;1"
			></animateTransform>
			<animate
				attributeName="stroke-dasharray"
				repeatCount="indefinite"
				dur="1.5s"
				values="18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882"
				keyTimes="0;0.5;1"
			></animate>
		</circle>
	</svg>
</ngx-loading>
